import { useContext } from 'react';
import { X } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import ThreadInputBoxContext from 'src/contexts/ThreadInputBoxContext';
import { Button } from 'src/v2/commonComponents/Button';
import styles from './ClearInputBoxButton.module.scss';

interface ClearInputBoxButtonProps {
  setFocused: (value: boolean) => void;
}

export const ClearInputBoxButton = ({
  setFocused,
}: ClearInputBoxButtonProps) => {
  const { onClearInputBox, onClearAttachments } = useContext(
    ThreadInputBoxContext,
  );

  const handleClearInput = () => {
    onClearInputBox();
    onClearAttachments();
    setFocused(false);
  };

  return (
    <Button
      className={styles.root}
      color="transparent"
      onClick={handleClearInput}
      shape="round"
    >
      <X size={SVG_SIZE_M} />
    </Button>
  );
};
